export function toArrayEntry(value) {
    return Array.isArray(value) ? value : [value];
}
//# sourceMappingURL=misc.js.map